import React, { useState } from 'react'
import { apiPost } from '~/util/api'
import { useResume } from './ResumeProvider'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { Button } from '../../lib/ui/button'
import DownloadPdfButton from './DownloadPdfButton'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from '../../lib/ui/dialog'
import { useTranslation } from '~/hooks/useTranslation'

const DownloadModal = () => {
  const { t } = useTranslation('DownloadModal')
  const [open, setOpen] = useState(false)
  const [isOpening, setIsOpening] = useState(false)

  const {
    resumeName,
    persistResumeIfChanged,
    documentId,
    docxEnabled,
    pdf: { blob },
  } = useResume()

  const downloadDocx = async () => {
    await persistResumeIfChanged()
    const path = `/resume/builder/docx`
    setIsOpening(true)
    const formData = new FormData()
    formData.append('file', blob, `${resumeName}.pdf`)
    try {
      const response = await apiPost(path, formData, true)
      setIsOpening(false)
      const a = document.createElement('a')
      a.href = response.data.file_location
      a.click()
      setOpen(false)
    } catch (e) {
      setIsOpening(false)
      console.error(e)
    }
  }

  const downloadText = async () => {
    await persistResumeIfChanged()
    const downloadPath = `/resume/builder/${documentId}.text`
    setIsOpening(true)
    try {
      const response = await fetch(downloadPath)
      setIsOpening(false)
      const text = await response.text()
      const blob = new Blob([text], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${resumeName}.txt`
      a.click()
      setOpen(false)
    } catch (e) {
      setIsOpening(false)
      console.error(e)
    }
  }

  return (
    <Dialog open={open} onOpenChange={() => setOpen(!open)}>
      <DialogTrigger asChild className="cursor-pointer">
        <Button variant="outline">
          {t('download')} <ArrowDownTrayIcon className="ml-2 w-6" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className="max-w-md overflow-hidden font-roboto"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">{t('download_resume')}</h2>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('select_download_format')}</DialogDescription>
        <div className="px-4 pb-4">
          <div className="flex flex-row justify-between">
            <DownloadPdfButton
              className="inline"
              text={t('pdf')}
              disabled={isOpening}
              onClick={() => setOpen(false)}
            >
              {t('pdf')}
            </DownloadPdfButton>
            <Button
              className="ml-4 inline"
              onClick={downloadText}
              disabled={isOpening}
              variant="outline"
            >
              {t('text')}
            </Button>
            {docxEnabled && (
              <Button
                className="ml-4 inline"
                onClick={downloadDocx}
                disabled={isOpening}
                variant="outline"
              >
                {t('ms_word')}
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DownloadModal
